var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartialDependencePlotOperationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "#272D55",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 10H1C0.447715 10 0 10.4477 0 11V16C0 16.5523 0.447715 17 1 17H3C3.55228 17 4 16.5523 4 16V11C4 10.4477 3.55228 10 3 10Z",
    fill: "#AECDFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 10.5H1C0.723858 10.5 0.5 10.7239 0.5 11V16C0.5 16.2761 0.723858 16.5 1 16.5H3C3.27614 16.5 3.5 16.2761 3.5 16V11C3.5 10.7239 3.27614 10.5 3 10.5Z",
    stroke: "#272D55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.5H6C5.44772 0.5 5 0.947715 5 1.5V16C5 16.5523 5.44772 17 6 17H8C8.55228 17 9 16.5523 9 16V1.5C9 0.947715 8.55228 0.5 8 0.5Z",
    fill: "#AECDFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 1H6C5.72386 1 5.5 1.22386 5.5 1.5V16C5.5 16.2761 5.72386 16.5 6 16.5H8C8.27614 16.5 8.5 16.2761 8.5 16V1.5C8.5 1.22386 8.27614 1 8 1Z",
    stroke: "#272D55"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 6H11C10.4477 6 10 6.44772 10 7V16C10 16.5523 10.4477 17 11 17H13C13.5523 17 14 16.5523 14 16V7C14 6.44772 13.5523 6 13 6Z",
    fill: "#AECDFC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13 6.5H11C10.7239 6.5 10.5 6.72386 10.5 7V16C10.5 16.2761 10.7239 16.5 11 16.5H13C13.2761 16.5 13.5 16.2761 13.5 16V7C13.5 6.72386 13.2761 6.5 13 6.5Z",
    stroke: "#272D55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartialDependencePlotOperationIcon);
export default __webpack_public_path__ + "static/media/PartialDependencePlotOperationIcon.11a1bf27d79579e42ac6b19228dd6fd9.svg";
export { ForwardRef as ReactComponent };